import { Duck } from '../components/Duck';
import { AIMM_EPISODES } from '../data/aiMinuteMondays';
import type { MascotName } from '../theme/ThemeProvider';

export function AIMinuteMondays({ mascot }: { mascot: MascotName }): JSX.Element {
  return (
    <section className="border-t-2 border-ink bg-bg px-8 py-[72px]">
      <div className="mx-auto max-w-[1280px]">
        <div className="grid items-stretch gap-8" style={{ gridTemplateColumns: '1fr 1.4fr' }}>
          {/* Left — parent-show pitch */}
          <div
            className="relative flex flex-col gap-4 overflow-hidden rounded-[18px] border-2 border-ink bg-ink p-8 text-bg"
            style={{ boxShadow: '6px 6px 0 rgb(var(--color-beak))' }}
          >
            <div aria-hidden className="absolute opacity-15" style={{ top: -30, right: -30 }}>
              <Duck variant={mascot} size={200} />
            </div>
            <div className="relative flex items-center gap-2.5">
              <span className="h-2 w-2 rounded-full bg-duck" />
              <span className="font-mono text-[11px] uppercase tracking-[0.16em] text-duck">THE PARENT SHOW</span>
            </div>
            <img
              src="/assets/ai-minute-mondays.png"
              alt="AI Minute with Suchi"
              className="relative my-1 max-w-[460px] object-contain"
              style={{ objectPosition: 'left center' }}
            />
            <p className="relative m-0 max-w-[460px] text-base leading-snug text-white/80">
              The Rubber Duck Debate is a special episode of <strong className="text-duck">AI Minute with Suchi</strong> — a weekly briefing on what actually shipped, what actually broke, and what we're actually arguing about.
            </p>
            <div className="relative mt-1 flex flex-wrap gap-2.5">
              <a
                href="#"
                className="inline-flex items-center gap-2 rounded-full bg-duck px-5 py-3 font-display text-[15px] font-extrabold text-ink no-underline"
              >
                Subscribe · free →
              </a>
              <a
                href="#"
                className="inline-flex items-center gap-2 rounded-full border-2 border-[rgb(var(--color-duck)/20%)] bg-transparent px-[18px] py-2.5 font-display text-sm font-semibold text-bg no-underline"
              >
                Browse all 37 episodes
              </a>
            </div>
            <div className="relative mt-auto flex gap-6 font-mono text-xs text-white/55">
              <span>
                <strong className="text-bg">37</strong> episodes
              </span>
              <span>
                <strong className="text-bg">11k</strong> subscribers
              </span>
              <span>
                <strong className="text-bg">4.8★</strong> avg
              </span>
            </div>
          </div>

          {/* Right — episode list */}
          <div className="flex flex-col gap-3">
            <div className="mb-1 flex items-baseline justify-between">
              <h3 className="m-0 font-display text-[22px] font-extrabold text-ink">Recent episodes</h3>
              <span className="font-mono text-[11px] tracking-[0.1em] text-ink-soft">LATEST FOUR</span>
            </div>
            {AIMM_EPISODES.map((e) => (
              <a
                key={e.num}
                href="#"
                className="grid items-center gap-5 rounded-xl border-2 border-ink bg-paper px-[22px] py-[18px] no-underline"
                style={{ gridTemplateColumns: '88px 1fr auto', boxShadow: '3px 3px 0 rgb(var(--color-ink))' }}
              >
                <div className="font-mono text-[13px] font-bold tracking-[0.06em] text-beak">EP · {e.num}</div>
                <div>
                  <div className="font-display text-[17px] font-bold leading-tight text-ink">{e.title}</div>
                  <div className="mt-1.5 flex gap-3 font-mono text-[11px] text-ink-soft">
                    {e.meta.map((m, i) => (
                      <span key={i}>{m}</span>
                    ))}
                  </div>
                </div>
                <span className="font-display text-lg font-extrabold text-ink">↗</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
